import styled from 'styled-components';
import theme from '../../theme';

const StyledOtpGeneration = styled.div`
padding: 1rem 2rem 0rem;
.otp-card{
  .ant-card-body{
    padding: 10px;
    .anticon-check-circle{
      color: ${theme.btnGreen};
      font-size: 26px;
    }
  }
}
.custom-otp-inputs{
  input{
    width: 3rem !important;
    padding: 12px 10px !important;
    border-radius: 12px;
    background-color: ${theme.whiteColor};
  }
}
`;

const StyledYesBankTNC = styled.div`
.custom-radio-btn{
  .ant-btn{
    padding: 8px 20px;
    background-color: ${theme.grayColor}50;
    height: auto;
    .ant-radio-wrapper{
      .ant-radio{
        .ant-radio-inner{
          border-color: ${theme.LandingBlack};
        }
      }
      &.ant-radio-wrapper-checked{
        .ant-radio-checked{
          .ant-radio-inner{
            border-color: ${theme.primaryColor};
            &::after{
              background-color: ${theme.primaryColor};
            }
          }
        }
      }
    }
  }
}
`;

const StyledYesTermsAndConditions = styled.section`
  height: 350px;
  overflow: scroll;
  text-align: left;
  border: #cccccc solid 1px;
  border-radius: 10px;
  padding: 10px 10px 10px 0px;
  .underline{
  text-decoration: underline;
}
`;


export {
  StyledOtpGeneration,
  StyledYesBankTNC,
  StyledYesTermsAndConditions,
};



// WEBPACK FOOTER //
// client/containers/PayBalance/StyledPayBalance.js